import PanelFilterGroupCollection from './PanelFilterGroupCollection.jsx';

export default PanelFilterGroupCollection;



// WEBPACK FOOTER //
// ./src/pages/Search/Main/FilterBar/PanelFilterGroupCollection/index.js